// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ActionNotification from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/MalwareScanning/ActionNotification';
import Rules from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/MalwareScanning/Rules';

const MalwareScanning = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Tabs>
        <TabList>
          <Tab>{t('policy.rules')}</Tab>
          <Tab>{t('policy.actionAndNotification')}</Tab>
        </TabList>
        <TabPanels py="2x">
          <TabPanel>
            <Rules applyBoundShow={false} />
          </TabPanel>
          <TabPanel>
            <ActionNotification
              advancedOptionShow={true}
              unscannableOptionShow={true}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
export default React.memo(MalwareScanning);
